/**
 * A ponte entre o layout (shared) e a identidade (feature).
 *
 * `shared/` não pode importar `features/` — é a regra de boundaries, e ela
 * existe justamente para o layout não ficar acoplado a uma feature. Então
 * a dependência é INVERTIDA: o app injeta o valor aqui, e o shell só lê.
 */

import { create } from 'zustand';

interface IdentidadeDoShell {
  nome: string;
  /**
   * Núcleo cuja fila a pessoa vê; `null` = papel transversal (vê todos). Serve às telas de `shared/`
   * e das features que precisam DIZER o escopo do que mostram, sem importar a feature de autenticação.
   */
  nucleoId: string | null;
  sair: () => void;
  definir: (valor: { nome: string; nucleoId: string | null; sair: () => void }) => void;
}

export const useIdentidadeDoShell = create<IdentidadeDoShell>()((set) => ({
  nome: '',
  nucleoId: null,
  sair: () => {
    /* substituído pelo app no boot */
  },
  definir: (valor) => {
    set(valor);
  },
}));
